import { docReady } from '../utils/docReady';
docReady(() => {
    const unmuteButtons = document.querySelectorAll('[data-video-unmute]');
    if (unmuteButtons.length) {
        unmuteButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const video = button.previousSibling;
                video.muted = !video.muted;
                button.classList.toggle('muted');
            });
        });
    }
});
